const shareButton = document.getElementById('product-share__button');
const shareList = document.getElementById('product-share__list');
const shareItems = document.querySelectorAll('.product-share__item');

shareButton.addEventListener('click', function(){
  if (this.getAttribute('aria-expanded') !== 'true') {
		this.setAttribute('aria-expanded', 'true');
    shareList.setAttribute('aria-hidden', 'false');
	} else {
		this.setAttribute('aria-expanded', 'false');
    shareList.setAttribute('aria-hidden', 'true');
	}
});

shareItems.forEach(function(element) {
	element.addEventListener('click', function(){
		shareButton.setAttribute('aria-expanded', 'false');
		shareList.setAttribute('aria-hidden', 'true');
	});
});
